import { WsReactBaseService } from '@thewhite/react-base-components';
import { BaseActions } from '@thewhite/react-global-module/lib/actions';
import { CollectionDTOInterface } from '@thewhite/react-global-module/lib/interfaces';
import { api } from '../../../config/api';
import { globalConfig } from '../../../config/globalConfig';
import { ParticipantPageParams } from '../interfaces/participantPageParams';
import Participant, { ParticipantDto, ParticipantType } from '../model/participant';

export class ParticipantsActions extends BaseActions {
    static DEFAULT_URL = `${globalConfig.api}/booking-service/participant/`;
    static api         = api;

    /**
     * Получить пэйджинированный список участников
     * @param params
     */
    static page = (params: ParticipantPageParams): Promise<CollectionDTOInterface<Participant>> => {
        return ParticipantsActions.COLLECTION_API_RESOURCE<ParticipantDto, Participant>({
            url: 'page',
            queryParams: params,
            model: Participant,
            modelType: ParticipantType,
        });
    };

    /**
     * Получить данные об участнике
     * @param id
     */
    static get = (id: string): Promise<Participant | null> => {
        return ParticipantsActions.MODEL_API_RESOURCE<ParticipantDto, Participant>({
            url: id,
            model: Participant,
            modelType: ParticipantType,
        });
    };

    /**
     * Подтвердить заявку
     * @param id
     */
    static approve = (id: string): Promise<null> => {
        return ParticipantsActions.API_RESOURCE(
            `${id}/approve`,
            WsReactBaseService.POST_METHOD,
        );
    };

    /**
     * Отклонить заявку
     * @param id
     * @param comment
     */
    static decline = (id: string, comment: string): Promise<null> => {
        return ParticipantsActions.API_RESOURCE(
            `${id}/decline`,
            WsReactBaseService.POST_METHOD,
            { value: comment },
        );
    };

    /**
     * Получить количество заявок по статусу
     * @param status
     */
    static getCountByStatus = (status?: string): Promise<number> => {
        return ParticipantsActions.API_RESOURCE('count/by-status', WsReactBaseService.GET_METHOD, { status })
                                  .then(res => res ?? 0);
    }
}
